import { useCallback, useEffect } from 'react';

export function useOnWindowFocus(onFocus: () => Promise<void>): void {
	const onVisibilityChange = useCallback(() => {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		if (document.visibilityState === 'visible') {
			onFocus();
		}
	}, [onFocus]);
	useEffect(() => {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		if (window?.addEventListener) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.addEventListener('visibilitychange', onVisibilityChange, false);

			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.addEventListener('focus', onFocus, false);
		}

		return () => {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			if (window?.removeEventListener) {
				// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
				window.removeEventListener('visibilitychange', onVisibilityChange);

				// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
				window.removeEventListener('focus', onFocus);
			}
		};
	});
}
